import React from 'react'
// components
import UsersContainer from 'containers/Users'

const UsersSettingsPage: React.FC = () => <UsersContainer />

export default UsersSettingsPage
